/**
 * @desc 销售负责人信息导入
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/salesOwnerInfo/import`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
